<template>
  <div class="field-spacing" :class="{ 'white-bg': whiteBackground }">
    <div class="d-flex flex-column">
      <label
        class="mb-2 body-12 text-500"
        :class="errorMessage ? 'label-error' : 'label-valid'"
        :for="name"
      >
        {{ label }}
      </label>
      <MultiSelect
        v-model="inputValue"
        :name="name"
        :options="options"
        :optionLabel="optionLabel"
        :optionValue="optionValue"
        :placeholder="placeholder"
      />
      <small v-show="errorMessage" class="p-invalid">{{ errorMessage }}</small>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'
import MultiSelect from 'primevue/multiselect'
import { useI18n } from 'vue-i18n'
import { useField } from 'vee-validate'

export default defineComponent({
  name: 'SelectMulti',
  components: { MultiSelect },
  props: {
    options: {
      type: Array as PropType<string[]>,
      required: true,
    },
    optionLabel: {
      type: String,
      default: 'name',
    },
    optionValue: {
      type: String,
      default: 'value',
    },
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    whiteBackground: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const { t } = useI18n()
    const { value: inputValue, errorMessage } = useField(props.name)
    return { t, errorMessage, inputValue }
  },
})
</script>

<style lang="scss" scoped></style>
